module.exports = __webpack_public_path__ + "img/VRCampus_einfarbig_RGB.8452621f.svg";